import { Component, OnInit , CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ActivatedRoute, Router, RouterModule } from "@angular/router";
import { Roles } from "../../../enums/roles";
import { Observable } from "rxjs";
import { IAppStore } from "../../../iappstore";
import { Store } from "@ngrx/store";
import { HeaderComponent } from "../../header/header.component";

@Component({
    selector: "categories",
    standalone: true,
    imports: [CommonModule, RouterModule, HeaderComponent],
    templateUrl: "./categories.component.html",
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class CategoriesComponent implements OnInit {
    roles: any = Roles;

    constructor(private activatedRoute: ActivatedRoute, private router: Router, private store: Store<IAppStore>) {
    }

    ngOnInit(): void {
        let adminRoles: string[] = [this.roles[this.roles.Admin], this.roles[this.roles.SuperAdmin]];
        this.store.select(e => e.user)
            .subscribe(user => {
                // Check if we're at the root categories path (no child route loaded)
                const currentUrl = this.router.url;
                const isAtCategoriesRoot = currentUrl === '/categories' || currentUrl === '/categories/';
                
                if (isAtCategoriesRoot && user && user.roles) {
                    if (user.roles.some(r => adminRoles.indexOf(r) >= 0)) {
                        this.router.navigate(["/categories/itemconfig"]);
                    } else if (user.roles.find(r => r === this.roles[this.roles.ContentEditor])) {
                        this.router.navigate(["/categories/managemetadata"]);
                    }
                }
            });
    }
}


